import { createAction } from '@reduxjs/toolkit';

export const addFavoriteLocation = createAction('app/location/add');
export const addCookieConsent = createAction('app/cookieconsent/add');
